import { render, staticRenderFns } from "./ShopHeadersPreview.vue?vue&type=template&id=40381e23&scoped=true"
import script from "./ShopHeadersPreview.vue?vue&type=script&lang=js"
export * from "./ShopHeadersPreview.vue?vue&type=script&lang=js"
import style0 from "./ShopHeadersPreview.vue?vue&type=style&index=0&id=40381e23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40381e23",
  null
  
)

export default component.exports